import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class AboutUsFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.AboutUs, "MultiJurisdictionCms.Dto.Features.AboutUsFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.AboutUsFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}